/*
 * The sections of the calculation window that the installation rows can be in besides
 * "installation and auxiliary work" and the other expenses: subcontracting and own
 * production. Their rows have the installation categories and their own summary rows with
 * their own hours; a row without a section is in one of the two by its category, as always.
 */

export const SUBCONTRACTING = 'subcontracting';
export const OWN_PRODUCTION = 'own-production';

export const INSTALLATION_SECTIONS = [SUBCONTRACTING, OWN_PRODUCTION];

// The section of a row, null for installation and auxiliary work or an other expense
export const sectionOf = (row: { section?: null | string }): null | string =>
  row.section || null;

interface ISectionVersion {
  averageHourlyEarnings: string;
  installerCount: string;
  ownProductionAverageHourlyEarnings?: string;
  ownProductionInstallerCount?: string;
  subcontractingAverageHourlyEarnings?: string;
  subcontractingInstallerCount?: string;
}

// The names of the fields of the version with the summary row of a section
export const contractFields = (
  section: null | string
): {
  averageHourlyEarnings: keyof ISectionVersion;
  installerCount: keyof ISectionVersion;
} => {
  if (section === SUBCONTRACTING) {
    return {
      averageHourlyEarnings: 'subcontractingAverageHourlyEarnings',
      installerCount: 'subcontractingInstallerCount',
    };
  }

  if (section === OWN_PRODUCTION) {
    return {
      averageHourlyEarnings: 'ownProductionAverageHourlyEarnings',
      installerCount: 'ownProductionInstallerCount',
    };
  }

  return {
    averageHourlyEarnings: 'averageHourlyEarnings',
    installerCount: 'installerCount',
  };
};

/** The average hourly earnings and the workers of the summary row of a section */
export const getContractValues = (
  version: ISectionVersion,
  section: null | string
): { averageHourlyEarnings: string; installerCount: string } => {
  const fields = contractFields(section);
  return {
    averageHourlyEarnings: version[fields.averageHourlyEarnings] ?? '',
    installerCount: version[fields.installerCount] || '1',
  };
};
